import React, { useState, useEffect } from "react";

const CustomAudioPlayer = ({
  src,
  audioRef,
  isAudioPlaying,
  setIsAudioPlaying,
  currentDemoIndex,
}) => {
  const [progress, setProgress] = useState(0); // Progress in percentage (0 to 100)
  const [volume, setVolume] = useState(1);
  const [duration, setDuration] = useState(0);

  const onLoadedMetadata = () => {
    setDuration(audioRef.current.duration);
  };

  const togglePlayPause = () => {
    if (audioRef.current.paused) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
    setIsAudioPlaying(!audioRef.current.paused);
  };

  const handleTimeUpdate = () => {
    const currentProgress =
      (audioRef.current.currentTime / audioRef.current.duration) * 100 || 0;
    setProgress(currentProgress);
  };

  const handleVolumeChange = (e) => {
    const newVolume = e.target.value;
    audioRef.current.volume = newVolume;
    setVolume(newVolume);
  };

  const handleProgressClick = (e) => {
    const progressBar = e.target;
    const clickPosition = e.nativeEvent.offsetX; // Get click position relative to the progress bar
    const progressBarWidth = progressBar.offsetWidth;
    const newProgress = (clickPosition / progressBarWidth) * 100;
    audioRef.current.currentTime =
      (audioRef.current.duration / 100) * newProgress;
    setProgress(newProgress);
  };

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = volume;
    }
  }, [volume, audioRef]);

  function formatTime(timeInSeconds) {
    var minutes = Math.floor(timeInSeconds / 60);
    var seconds = Math.floor(timeInSeconds % 60);

    // Pad with leading zeros if necessary
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return minutes + ":" + seconds;
  }

  useEffect(() => {
    audioRef.current.pause();
    setIsAudioPlaying(false);
    audioRef.current.currentTime = 0;
    setProgress(0);
  }, [audioRef, currentDemoIndex, setIsAudioPlaying]);

  return (
    <div key={currentDemoIndex} className="flex items-center">
      <audio
        ref={audioRef}
        onLoadedMetadata={onLoadedMetadata}
        onTimeUpdate={handleTimeUpdate}
        onEnded={() => setIsAudioPlaying(false)}>
        <source src={src} />
        Your browser does not support the audio tag.
      </audio>

      <div className="flex flex-col items-center gap-2">
        <div className="text-purple-100 text-xs font-medium flex gap-1 self-start">
          <span className="text-inherit font-inherit w-[1.6rem]">
            {formatTime(Math.floor(audioRef?.current?.currentTime))}
          </span>
          <span className="text-inherit font-inherit">/</span>
          <span className="text-inherit font-inherit w-[1.6rem]">
            {formatTime(duration)}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <div
            className="w-[70vw] sm:w-[20rem] h-1.5 bg-gray-200 rounded-[2px] relative cursor-pointer"
            onClick={handleProgressClick}
            style={{
              background: `linear-gradient(to right, #ffffff ${progress}%, #242344 ${progress}%)`,
            }}></div>

          {/* <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={volume}
            onChange={handleVolumeChange}
            className="w-24 h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
          /> */}
        </div>
        <button
          onClick={togglePlayPause}
          className=" text-white font-bold py-2 px-4 rounded">
          {!!!isAudioPlaying ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              className="w-10 h-10 fill-white">
              <path
                fillRule="evenodd"
                d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                clipRule="evenodd"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              className="w-10 h-10 fill-white">
              <path
                fillRule="evenodd"
                d="M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z"
                clipRule="evenodd"
              />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default CustomAudioPlayer;
